var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnderline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 18,
    viewBox: "0 0 17 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.10896 15.1362C6.22661 15.1362 4.76107 14.5984 3.71233 13.5227C2.66359 12.4471 2.13922 10.9009 2.13922 8.88407V0.857178H4.15602V8.8034C4.15602 11.8286 5.48039 13.3412 8.12913 13.3412C9.41989 13.3412 10.4081 12.9715 11.0938 12.232C11.7796 11.479 12.1224 10.3362 12.1224 8.8034V0.857178H14.0787V8.88407C14.0787 10.9143 13.5543 12.4673 12.5056 13.5429C11.4569 14.6051 9.99132 15.1362 8.10896 15.1362Z",
    fill: "#2D72FE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.142578 16.9916H16.0955V18H0.142578V16.9916Z",
    fill: "#2D72FE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnderline);
export default __webpack_public_path__ + "static/media/underline.3d8629ededfd0ce0396f5a488662f213.svg";
export { ForwardRef as ReactComponent };